/*
* CAME CONFIG for SCAN
* Change selected Games in Config depending upon free or intern version
* GAMES.scanClassic and GAMES.scanJoker are free
* */

const GAMES = {
    scanClassic : {
        id: 1,
        name: 'game.scanClassic.name',
        description: 'game.scanClassic.description',
        faq: 'game.scanClassic.faq',
        cardsSetup: {
            max: 25,
            rows: 3,
            random: true,
            lastOpen: true,
            allOpen: false,
        },
        allowedUserAction: {
            zoom: true,
            turn: true
        },
        selectionOptions: {
            title: 'game.scanClassic.selection.text',
            defaultSpaces: 4,
            specialSpaces: 1,
            specialInfo: 'game.scanClassic.specialSelection.text',
            parties: [{title: ""}],
        }
    },
    scanJoker : {
        id: 2,
        name: 'game.scanJoker.name',
        description: 'game.scanJoker.description',
        faq: 'game.scanJoker.faq',
        badge: false,
        cardsSetup: {
            max: 25,
            rows: 3,
            random: true,
            lastOpen: true,
            allOpen: false,
        },
        allowedUserAction: {
            zoom: true,
            turn: true
        },
        selectionOptions: {
            title: 'game.scanJoker.selection.text',
            defaultSpaces: 4,
            specialSpaces: 1,
            specialInfo: 'game.scanJoker.specialSelection.text',
            parties: [{title: ""}],
            specialAction: {
                btnAction: 'showRandomCard',
                btnText: 'game.scanJoker.specialSelection.btn'
            },
        }
    },
    feelingsTurned : {
        id: 3,
        name: 'game.feelingsTurned.name',
        description: 'game.feelingsTurned.description',
        faq: 'game.feelingsTurned.faq',
        badge: false,
        cardsSetup: {
            max: 25,
            rows: 2,
            random: true,
            lastOpen: false,
            allOpen: false,
        },
        allowedUserAction: {
            zoom: true,
            turn: true
        },
        selectionOptions: {
            title: 'game.feelingsTurned.selection.text',
            defaultSpaces: undefined,
            specialSpaces: undefined,
            parties: [{title: ""}],
        }
    },
    tellingStories : {
        id: 4,
        name: 'game.tellingStories.name',
        description: 'game.tellingStories.description',
        faq: 'game.tellingStories.faq',
        badge: false,
        cardsSetup: {
            max: 25,
            rows: 2,
            random: true,
            lastOpen: false,
            allOpen: false,
        },
        allowedUserAction: {
            zoom: true,
            turn: true
        },
        selectionOptions: {
            title: 'game.tellingStories.selection.text',
            defaultSpaces: undefined,
            specialSpaces: undefined,
            parties: [{title: ""}],
        }
    },
    likeLife : {
        id: 5,
        name: 'game.likeLife.name',
        description: 'game.likeLife.description',
        faq: 'game.likeLife.faq',
        badge: false,
        cardsSetup: {
            max: 25,
            rows: 2,
            random: true,
            lastOpen: true,
            allOpen: false,
            grouped: 2,
            sortedInGroup: false,
        },
        allowedUserAction: {
            zoom: true,
            turn: true
        },
        selectionOptions: {
            title: 'game.likeLife.selection.text',
            defaultSpaces: undefined,
            specialSpaces: undefined,
            parties: [{title: ""}],
        }
    },
    mediation : {
        id: 6,
        name: 'game.mediation.name',
        description: 'game.mediation.description',
        faq: 'game.mediation.faq',
        badge: false,
        cardsSetup: {
            max: 100,
            rows: 3,
            random: false,
            lastOpen: true,
            allOpen: true,
            grouped: 4,
        },
        allowedUserAction: {
            zoom: true,
            turn: true
        },
        selectionOptions: {
            title: 'game.mediation.selection.text',
            defaultSpaces: 3,
            titleB: 'game.mediation.selection.textB',
            defaultSpacesB: 3,
            specialSpaces: 1,
            specialInfo: 'game.mediation.specialSelection.text',
            parties: [{title: "A"}, {title: "B"}],
        }
    },
    mediation3 : {
        id: 7,
        name: 'game.mediation.name',
        description: 'game.mediation3.description',
        faq: 'game.mediation.faq',
        badge: false,
        cardsSetup: {
            max: 125,
            rows: 3,
            random: false,
            lastOpen: true,
            allOpen: true,
            grouped: 5,
        },
        allowedUserAction: {
            zoom: true,
            turn: true
        },
        selectionOptions: {
            title: 'game.mediation.selection.text',
            defaultSpaces: 3,
            titleB: 'game.mediation.selection.textB',
            defaultSpacesB: 3,
            specialSpaces: 1,
            specialInfo: 'game.mediation.specialSelection.text',
            parties: [{title: "A"}, {title: "B"}, {title: "C"}],
        }
    },
    creative : {
        id: 8,
        name: 'game.creative.name',
        description: 'game.creative.description',
        faq: 'game.creative.faq',
        cardsSetup: {
            max: 100,
            rows: 3,
            random: true,
            lastOpen: true,
            allOpen: true,
            grouped: 4,
            sortedInGroup: true,
        },
        allowedUserAction: {
            zoom: true,
            turn: true
        },
        selectionOptions: {
            title: 'game.creative.selection.text',
            fixedHeight: 4,
            defaultSpaces: undefined,
            specialSpaces: undefined,
            parties: [{title: ""}],
        }
    },
    creativeS : {
        id: 9,
        name: 'game.creativeS.name',
        description: 'game.creativeS.description',
        faq: 'game.creativeS.faq',
        cardsSetup: {
            max: 100,
            rows: 3,
            random: false,
            lastOpen: true,
            allOpen: true,
            grouped: 4,
            sortedInGroup: true
        },
        allowedUserAction: {
            zoom: true,
            turn: true
        },
        selectionOptions: {
            title: 'game.creativeS.selection.text',
            fixedHeight: 4,
            defaultSpaces: undefined,
            specialSpaces: undefined,
            parties: [{title: ""}],
        }
    },
    magicStick : {
        id: 10,
        name: 'game.magicStick.name',
        description: 'game.magicStick.description',
        faq: 'game.magicStick.faq',
        badge: 'badgeText.new',
        cardsSetup: {
            max: 50,
            rows: 3,
            random: true,
            lastOpen: true,
            allOpen: false,
            grouped: 2,
            sortedInGroup: false
        },
        allowedUserAction: {
            zoom: true,
            turn: true
        },
        selectionOptions: {
            title: 'game.magicStick.selection.text',
            defaultSpaces: 9,
            specialSpaces: 1,
            specialInfo: 'game.magicStick.specialSelection.text',
            parties: [{title: "Coachee"}]
        }
    }
};

export const Games = {
    cardConfig: {
        cardHeight: 17,
        cardRatio: 1.5478,
        cardSpace: 1.5,
    },
    items: [
        GAMES.scanClassic,
        GAMES.scanJoker,
        /* was only for internscan */
        GAMES.tellingStories,
        GAMES.feelingsTurned,
        GAMES.mediation,
        GAMES.mediation3,
        GAMES.likeLife,
        GAMES.creative,
        GAMES.creativeS,
        GAMES.magicStick
    ],
};
